/** @jsxImportSource @emotion/react */
import { Minus, Plus } from '../../../Icons';
import useStyle from './style';

type QtyInputProps<T> = {
  value: T;
  onChange: (newValue: T) => void;
  min?: T;
  max?: T;
};

const QtyInput = ({ value, onChange, min, max }: QtyInputProps<number>) => {
  const s = useStyle();

  const handleChange = (val: number) => {
    if (!!min && val < min) {
      return;
    }
    if (!!max && val > max) {
      return;
    }
    onChange(val);
  };

  return (
    <div css={s.qtyWrapper}>
      <button
        css={s.qtyButton}
        aria-label="Remove One"
        type="button"
        onClick={() => handleChange(value - 1)}
      >
        <Minus />
      </button>
      <span css={s.qtyValue}>{value}</span>
      <button
        css={s.qtyButton}
        aria-label="Add One"
        type="button"
        onClick={() => handleChange(value + 1)}
      >
        <Plus />
      </button>
    </div>
  );
};

export default QtyInput;
